import Image from 'next/image';

import { Headline } from '~components/Typography';
import { useTranslations } from '~i18n/hooks';

import { NeuronsCost } from './NeuronsBadge.styles';

type TNeuronsBadge = {
	showPrice: boolean;
	cost: number | undefined;
};

export const NeuronsBadge = ({ showPrice, cost }: TNeuronsBadge) => {
	const t = useTranslations('Chats');

	return (
		<NeuronsCost data-name="neurons-badge">
			{showPrice && (cost ?? 0 > 0) ? (
				<>
					<Headline size="M">{cost}</Headline>
					<Image
						src="/img/neurons/gem-icon.png"
						width={22}
						height={22}
						quality={100}
						alt="neuron image"
					/>
				</>
			) : (
				<Headline size="S">{t('paidMessageAction')}</Headline>
			)}
		</NeuronsCost>
	);
};
